import axios from "@/api/axiosInstance";
import { FetchRecurringEmailsResponse } from "./types";

export const fetchRecurringEmails =
  async (): Promise<FetchRecurringEmailsResponse> => {
    const response = await axios.get<FetchRecurringEmailsResponse>(
      "/api/private/recurring-emails",
    );
    return response.data;
  };
